<template>
  <div>
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="정산 예정 조회"
      desc="정산 예정으로 들어온 내역을 조회할 수 있습니다."
    ></admin-filter>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="1400"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">

      <div slot="partner_name" slot-scope="props">
        {{ props.item.partner_name }}
      </div>

      <div slot="created_time" slot-scope="props">{{ props.item.created_time }}</div>

      <div slot="expect_date" slot-scope="props">
        <!--<span v-if="!props.item.expect_date">-</span>-->
        <!--<span v-else>{{ props.item.expect_date }}</span>-->
        {{ accountType0(props.item) }}
      </div>

      <div slot="min_price" slot-scope="props">
        <!--<span v-if="isAccountPrice(props.item)">{{ account_setting.account_price | currency }} 이상</span>-->
        <!--<span v-else>-</span>-->
        <span v-if="accountType1(props.item)==='-'">{{ accountType1(props.item) }}</span>
        <span v-else>
          {{ accountType1(props.item) | currency }}
        </span>
      </div>

      <div slot="total_price" slot-scope="props">
        {{ props.item.total_price | currency }}
      </div>

      <div slot="comm_price" slot-scope="props">
        {{ props.item.comm_price | currency }}
      </div>

      <div slot="coupon_price" slot-scope="props">
        {{ props.item.coupon_price | currency }}
      </div>

      <div slot="point" slot-scope="props">
        {{ props.item.point | currency }}
      </div>

      <div slot="acc_price" slot-scope="props">
        {{ calcAccPrice(props.item) | currency }}
      </div>

      <div slot="history" slot-scope="props">
        <button class="button" @click="openHistory(props.item.id)">내역보기</button>
      </div>

      <div slot="modify_delete" slot-scope="props">
        <button class="button"
                :class="{'active': disableAccount(props.item)}"
                :disabled="!disableAccount(props.item)"
                @click="clickAccount(props.item)">정산완료하기</button>
        <!--<button class="button"
                :class="{'active': checkAccountSetting(props.item)}"
                :disabled="!checkAccountSetting(props.item)"
                @click="clickAccount(props.item)" v-else>정산완료하기</button>-->
      </div>
    </admin-table>

    <modal name="accountSuccessModal"
           :adaptive="true"
           :width="600"
           height="auto"
           class="modal-style">
      <div class="lp-modal-wrapper">
        <div>정산 완료 처리</div>
        <div>정산 완료 하시겠습니까?</div>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="cancelModal">취소</button>
          <button class="button is-primary" @click="confirmModal">확인</button>
        </div>
      </div>
    </modal>

    <modal name="historyModal"
           :adaptive="true"
           :width="900"
           :height="600"
           style="overflow-y: scroll"
           class="modal-style">
      <div class="lp-modal-wrapper" v-if="detail">
        <div class="btn-group-justify-end" style="padding:0 12px">
          <i class="material-icons modal-exit" @click="$modal.hide('historyModal')">close</i>
        </div>
        <table class="table">
          <thead>
          <tr>
            <th>주문번호</th>
            <th>주문자</th>
            <th>상품명</th>
            <th>주문금액</th>
            <th>구매일</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(order,idx) in detail.orders" :key="'history-'+idx">
            <td>{{ order.id }}</td>
            <td>{{ order.order_name }}</td>
            <!-- 주문 상품 -->
            <td>
              <div class="flex align-center">
                <img :src="order.product_img" style="width:35px;height:35px;margin-right:6px" v-if="order.product_img">
                <div style="text-align: left">{{ order.product_name }}</div>
              </div>
            </td>
            <td>{{ order.total_price | currency }}</td>
            <td>{{ convertDate(order.created_time, 'datetime') }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </modal>
  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'
  export default {
    name: 'AccountNew',
    components: {},
    mixins: [
      ListMixin
    ],
    data() {
      return {
        account_id:'',
        partner_id:'',
        accountItem: undefined,
        // 정산 설정
        account_setting: {},
        detail: undefined
      }
    },
    created() {
      this.init();
    },
    methods: {
      init() {
        // 정산 처리 안되어있는 경우 isnull=true
        this.initializing('account_new', 'reservation/nonaccount');

        if(this.isAdmin){
          this.$axios.get('admin/reservation/account/setting').then(res=>{
            this.account_setting = res.data;
          })
        }

        if(!this.isAdmin) {
          this.initField();
        }
      },
      getDataFromServer() {
        this.getData();
      },
      calcAccPrice(item) {
        return item.total_price - item.comm_price - item.coupon_price - item.point;
      },
      initField() {
        for(let i=0; i<this.tableData.length; i++){
          if(this.tableData[i].eng_name==='modify_delete') {
            this.tableData.splice(i, 1);
          }
        }
      },
      accountType0(item) {
        if(!this.account_setting.is_account) return '-';
        // 최소 금액이상 정산
        else if(this.account_setting.account_type === 1) {
          return '-'
        }
        // 날짜
        else if(this.account_setting.account_type===0) {
          return item.expect_date
        }
      },
      accountType1(item) {
        if(!this.account_setting.is_account) return '-';
        // 최소 금액이상 정산
        else if(this.account_setting.account_type === 1) {
          return this.account_setting.account_price
        }
        // 날짜
        else if(this.account_setting.account_type===0) {
          return '-'
        }
      },
      isAccountPrice(item) {
        if(!item.expect_date && this.account_setting.is_account) return true;
        else return false;
      },
      disableAccount(item) {
        // 날짜 기준이 아닐 경우 ( 금액 기준일 경우 )
        if(this.account_setting.is_account && this.account_setting.account_type===1) {
          let acc_price = this.calcAccPrice(item);
          if(acc_price>=this.account_setting.account_price) return true;
          else return false;
        }
        else return true;
      },
      openHistory(id) {
        this.$store.commit('setLoading', true);
        this.$axios.get(this.getUrl(`reservation/nonaccount/${id}`)).then(res=> {
          this.$store.commit('setLoading', false);
          this.detail = res.data;
          this.$modal.show('historyModal');
        })
      },
      clickAccount(item){
        let acc_price = this.calcAccPrice(item);
        this.account_id = item.id;
        this.partner_id = item.partner;
        // this.acc_price = acc_price;
        this.accountItem = item;
        this.accountItem.acc_price = acc_price;
        this.$modal.show('accountSuccessModal');
      },
      cancelModal(){
        this.$modal.hide('accountSuccessModal');
      },
      confirmModal(){
        let value = undefined;
        value = this.accountItem;
        value.partner_id = this.partner_id;
        this.$axios.post(this.getUrl(`reservation/account/${this.account_id}/success`), value).then(res=>{
          if(res.status===200){
            this.toast('정산완료 처리되었습니다.');
            this.$modal.hide('accountSuccessModal');
            this.getData();
          }
        }).catch(error => {
          if (error.response.status > 400) {
            if(error.response.data.message)
              this.toast(error.response.data.message);
            else if(error.response.data.detail)
              this.toast(error.response.data.detail);
            this.$modal.hide('accountSuccessModal');
          }
        })
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .active
    background-color $primary
    color white

  .modal-exit
    padding 8px
    cursor pointer

  .modal-exit:hover
    color white
    background-color $primary
    border-radius 50%
</style>
